export default {
    activeChat(state, payload) {
        state.activeChat = payload;
    },
    typing(state, typing) {
        state.typing = typing;
    },
    receivedMessage(state, message) {
        const activeChatUserId = state.activeChat.user_id;
        if (!state.messages[activeChatUserId]) {
            state.messages[activeChatUserId] = [];
        }
        state.messages[activeChatUserId].push(message);
    },
    fetchMessage(state, messages) {
        const activeChatUserId = state.activeChat.user_id;
        if (!state.messages[activeChatUserId]) {
            state.messages[activeChatUserId] = [];
        }
        state.messages[activeChatUserId] = messages;
    }
}